import React, { useEffect, useState, useCallback } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useSelector } from "react-redux";
import { TbPlus } from "react-icons/tb";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import ButtonDanger from "@areas/shared/components/buttons/ButtonDanger";
import CustomModal from "@areas/shared/components/personal/modals/CustomModal";
import { fetchWrapper } from "@helpers/fetchwrapper";

import Table from "./blocks/Table";
import {
  initialValues,
  validationSchema,
  confirm,
  ModalBodyAdd,
} from "./blocks/ModalAdd";

function Frame() {
  const { company: currentCompany } = useSelector((x) => x.auth);
  const [showModal, setShowModal] = useState(false);
  const [headerModal, setHeaderModal] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
  const [specialistNeed, setSpecialistNeed] = useState(null);

  const loadData = useCallback(() => {
    setLoad(true);
    fetchWrapper
      .get(
        `/v1/api/app/GetSpecialistNeedsByCompanyId?offset=${
          page * perPage - perPage
        }&limit=${perPage}&idCompany=${currentCompany.IdCompany}`
      )
      .then((res) => {
        setData(res.data || []);
        setTotal(res.total || res.Total || 0);
        setLoad(false);
      })
      .catch(() => {
        setLoad(false);
      });
  }, [page, perPage, currentCompany]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const toggle = useCallback(
    (item) => {
      if (showModal) {
        setShowModal(false);
        setSpecialistNeed(null);
      } else {
        if (!item) {
          setHeaderModal("Добавление потребности в специалисте");
        } else {
          setHeaderModal("Редактирование потребности в специалисте");
        }
        setSpecialistNeed(item);
        setShowModal(true);
      }
    },
    [showModal]
  );

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = async (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  return (
    <div>
      <Animation
        animationIn={animationStyles.fadeIn}
        animationOut={animationStyles.fadeOut}
      >
        <Card>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Требуемые специалисты</h5>
              <ButtonDanger onClick={() => toggle()}>
                <TbPlus />
                Добавить
              </ButtonDanger>
            </div>
          </CardHeader>
          <CardBody>
            <Table
              load={load}
              data={data}
              total={total}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
              toggleModal={toggle}
            />
          </CardBody>
        </Card>
        <CustomModal
          isOpen={showModal}
          toggle={toggle}
          header={headerModal}
          body={(validation) => <ModalBodyAdd validation={validation} />}
          validateYupSchema={validationSchema}
          inititalValues={() => initialValues(specialistNeed, currentCompany)}
          cancel="Закрыть"
          confirm="Сохранить"
          confirmFunction={(values) => {
            confirm(values, () => {
              setShowModal(false);
              setSpecialistNeed(null);
              loadData();
            });
          }}
        />
      </Animation>
    </div>
  );
}

export default Frame;
